import { useEffect } from 'react'
import { useMediaQuery } from 'react-responsive'
import { useLocation } from 'react-router-dom'

import styles from './styles.module.scss'

import Footer from './components/Footer/Footer'
import Header from './components/Header/Header'
import MoreRecordsSection from './components/MoreRecordsSection/MoreRecordsSection'
import Stepper from './components/Stepper/Stepper'

import { initMainPage } from './initMainPage'

const MainPage = () => {
  const isDesktop = useMediaQuery({ minWidth: 1440 })
  const { hash } = useLocation()

  useEffect(() => {
    if (!hash) {
      return
    }

    if (hash === '#stepperMobile' || hash === '#records') {
      setTimeout(() => {
        document.querySelector('#records')?.scrollIntoView({
          behavior: 'smooth',
        })
      }, 100)

      return
    }

    if (hash.includes('section')) {
      document.querySelector(hash)?.scrollIntoView({
        behavior: 'instant',
      })
    }
  }, [hash])

  useEffect(() => {
    const cleanup = initMainPage()

    return () => {
      cleanup?.()
    }
  }, [])

  return (
    <div className={styles.main}>
      {isDesktop && <div className={styles.topline} />}

      <Header />
      <Stepper />
      <MoreRecordsSection />
      <Footer />
    </div>
  )
}

export default MainPage